import { DynamicAttribute } from '@/models/Item';
import { ApplicationState } from '@/store';
import React from 'react';
import 'react-quill/dist/quill.snow.css';
import { useSelector } from 'react-redux';
import './style.scss';

interface ContentTypeProps {
    setType: (fieldName: string, value: DynamicAttribute) => void;
    type: DynamicAttribute | undefined;
}

const video = { method: 'URL', type: 'VIDEO' };
const audio = { method: 'URL', type: 'AUDIO' };
const article = { method: 'URL', type: 'HTML' };

const ContentType = ({ setType, type }: ContentTypeProps) => {
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);
    return (
        <div className="card-content">
            <div className="row">
                <div className="container button-group-content-type">
                    <button
                        className={`btn btn-primary btn-lg ${type && type.type === 'VIDEO' ? 'active' : ''}`}
                        onClick={() => setType('type', video)}
                        type="button"
                    >
                        <i className="material-icons-outlined align-middle">videocam</i>
                        <span className="align-middle">{strings.VIDEO}</span>
                    </button>

                    <button
                        className={`btn btn-primary btn-lg ${type && type.type === 'AUDIO' ? 'active' : ''}`}
                        onClick={() => setType('type', audio)}
                        type="button"
                    >
                        <i className="material-icons-outlined align-middle">mic_none</i>
                        <span className="align-middle">{strings.AUDIO}</span>
                    </button>
                    <button
                        className={`btn btn-primary btn-lg ${type && type.type === 'HTML' ? 'active' : ''}`}
                        onClick={() => setType('type', article)}
                        type="button"
                    >
                        <i className="material-icons-outlined align-middle">description</i>
                        <span className="align-middle">{strings.ARTICLE}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ContentType;
